<template>
	<div class="container">
		<el-upload :disabled="disabled" class="upload-demo" name="upload_file" :action="baseUrl+'audit/upload_file'"
			:on-preview="handlePreview" :on-remove="handleRemove" :headers="headers" :before-remove="beforeRemove"
			:limit="limit" :multiple="limit>1" :before-upload="beforeUpload" :on-exceed="handleExceed"
			:on-success="handleSuccess" :file-list="fileList" :accept="accept" :http-request="ossUploadFile">
			<!-- :http-request="ossUploadFile" -->
			<div class="col-center">
				<el-button :disabled="disabled" type="primary">{{text}}</el-button>
				<div slot="tip" class="el-upload__tip">
					<slot name="tips">{{tips}}</slot>
					<div v-if="subtext" style="color: red;">{{subtext}}</div>
					<div v-if="tipslink" class="tipslink" @click.stop="download">{{tipslink}}</div>
					<!-- <div>单个附件大小不能超过10MB</div> -->
				</div>
			</div>
		</el-upload>
	</div>
</template>

<script>
	// 文件上传获取上传路径
	import {
		baseUrl
	} from '@/common/config.js'
	let urlRes = ''
	urlRes = window.location.protocol + "//" + window.location.host + "/api/"
	if (urlRes.indexOf('localhost') !== -1) {
		urlRes = 'http://10.0.7.202:9093/api/'
	}
	if (baseUrl) {
		urlRes = baseUrl
	}
	// oss上传
	import COS from 'cos-js-sdk-v5';
	// 获取配置
	import {
		getOssConfig,
		getOssUrl
	} from '@/common/api/public.js'
	export default {
		name: '',
		props: {
			disabled: {
				type: Boolean,
				default: false
			},
			localList: {
				type: Array,
				default () {
					return []
				}
			},
			tips: {
				type: String,
				default: '只能上传 Pdf / Excel / Word文件'
			},
			accept: {
				type: String,
				default: '.pdf, .doc, .docx, .xls, .xlsx'
			},
			limit: {
				type: Number,
				default: 1
			},
			text: {
				type: String,
				default: '点击上传附件'
			},
			subtext: {
				type: String,
				default: ''
			},
			tipslink: {
				type: String,
				default: ''
			},
			linkUrl: {
				type: String,
				default: ''
			},
			size: {
				type: Number,
				default: 500
			}
		},
		components: {

		},
		watch: {
			localList: {
				handler(v) {
					console.log(v, 33333333)
					if (v.length && !this.isInnerFlag) {
						this.fileList = v
						this.isInnerFlag = false
					}
				},
				deep: true,
				immediate: true,
			}
		},
		data() {
			return {
				baseUrl: urlRes,
				fileList: [],
				files: [],
				headers: {
					Authorization: ''
				},
				isInnerFlag: false,
				isShowRemoveTip: true,
				taskId: ''
			}
		},
		created() {
			let token = localStorage.getItem('access_token')
			this.headers.Authorization = "Bearer " + token
		},
		mounted() {},
		methods: {
			// 限制上传大小
			beforeUpload(file) {
				// console.log(file, this.size * 1024 * 1024)
				// if (file.size > this.size * 1024 * 1024) {
				// 	this.isShowRemoveTip = false
				// 	this.$message.error('文件大小不能超过' + this.size + 'MB')
				// 	return false
				// }
			},
			// 附件相关
			handleRemove(file, fileList) {
				this.isInnerFlag = true
				this.files = fileList.filter((item) => {
					if ((item.response && item.response.status_code == 200) || (item.url && item.size &&
							item
							.name)) {
						return item
					}
				}).map(item => {
					if (item.url && item.size && item.name) {
						return item
					} else {
						return item.response.data[0]
					}
				})
				this.$emit('success', this.files)
			},
			handlePreview(file) {
				console.log(file);
				let url = file.link_url || file.url
				if (!url) {
					url = file.response.data[0].url
				}
				window.open(url, '_blank')
				// this.viewFile(url)
			},
			handleExceed(files, fileList) {
				this.$message.error(
					`当前限制选择 ${this.limit} 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
			},
			beforeRemove(file, fileList) {
				if (this.isShowRemoveTip) {
					return this.$confirm(`确定移除 ${ file.name }？`, '提示', {
						lockScroll: false
					});
				} else {
					this.isShowRemoveTip = true
					return true
				}

			},
			handleSuccess(response, file, fileList) {
				console.log(fileList, 44444444)
				this.isInnerFlag = true
				this.files = fileList.filter((item) => {
					if ((item.response && item.response.status_code == 200) || (item.url && item.size && item
							.name)) {
						return item
					}
				}).map(item => {
					if (item.url && item.size && item.name) {
						return item
					} else {
						return item.response.data[0]
					}
				})
				this.$emit('success', this.files)
			},
			async ossUploadFile(options) {
				console.log(options, 'optionsoptionsoptions')
				let fileName = options.file.name.replace(/\s+/g, '')
				let nameKey = this.generateRandomString(10) + '.' + fileName.match(/\.(.+)$/)[1]
				console.log(nameKey, ':http-request="ossUploadFile"')
				const {
					data
				} = await getOssConfig()
				let ossConfig = data
				console.log(data)
				const cos = new COS({
					SecretId: data.secretId,
					SecretKey: data.secretKey,
					SecurityToken: data.SecurityToken,
				});
				cos.uploadFile({
					Bucket: data.Bucket,
					Region: data.region,
					Key: data.Key + "/" + nameKey,
					Body: options.file,
					SliceSize: 1024 * 1024 * 10,
					onTaskReady: (tid) => {
						this.taskId = tid;
					},
					onProgress: (progressData) => {
						options.onProgress({
							percent: progressData.percent * 100
						});
						console.log('上传中', JSON.stringify(progressData));
					},
					onSuccess: (response) => {
						console.log(response, 'response')
						// options.onSuccess(response.data);
					}
				}, async (err, result) => {
					if (err) {
						console.error(err)
						options.onError(err);
						this.$u.toast('上传失败')
					} else {
						console.log(result, '8888888');
						if (result.statusCode == 200) {
							const {
								data
							} = await getOssUrl({
								Key: ossConfig.Key + "/" + nameKey
							})
							console.log(data, '换取链接')

							options.onSuccess({
								status_code: 200,
								data: [{
									Key: ossConfig.Key + "/" + nameKey,
									link_url: data.url,
									name: fileName,
									size: options.file.size,
									url: data.url,
								}]
							});
						} else {
							this.$u.toast('上传失败')
						}
					}
				});
			},
			// 操作菜单
			handleCommand(command, url) {
				if (command === 'download') {
					window.open(url, '_blank')
				} else {
					this.viewFile(url)
				}
			},
			// 在线预览
			viewFile(url) {
				let onlineViewType = ['doc', 'docx', 'xls', 'xlsx', 'xlsm', 'ppt', 'pptx']
				let fileTypeName = url.substring(url.lastIndexOf('.') + 1, url.length).split('?')[0]
				let isWord = onlineViewType.find((type) => type === fileTypeName)
				if (isWord) {
					url = 'http://view.officeapps.live.com/op/view.aspx?src=' + url
				}
				window.open(url, '_blank')
			},
			generateRandomString(length) {
				let result = '';
				const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
				const timestamp = new Date().getTime();

				for (let i = 0; i < length; i++) {
					const randomIndex = Math.floor(Math.random() * (characters.length));
					result += characters.charAt(randomIndex);
				}
				return result + timestamp;
			},
			download(){
				if(this.linkUrl){
					window.open(this.linkUrl)
				}
			}
		}

	}
</script>

<style lang="scss" scoped>
	.el-upload__tip {
		line-height: 1.25rem;
		text-align: left;
		padding-left: 0.625rem;
	}
	.tipslink{
		cursor: pointer;
		color: #4979ff;
		text-decoration: underline;
	}
	.tipslink:hover{
		color: blue;
	}
	::v-deep .el-icon-close-tip {
		display: none !important;
	}
</style>